import { createStyles, withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import * as React from 'react';
import { compose, pure } from 'recompose';
const styles = () => createStyles({
    innerShadow: {
        position: 'absolute',
        left: 0,
        width: '100%',
        height: 10,
        zIndex: 99,
    },
    top: {
        boxShadow: 'inset 0px 7px 20px -8px rgba(0,0,0,0.6)',
        top: 0,
    },
    bottom: {
        boxShadow: 'inset 0px -5px 8px rgba(0,0,0,0.2)',
        bottom: 0,
    },
});
const InnerShadow = (props) => {
    const { classes, testId = 'InnerShadow', position = 'top' } = props;
    return React.createElement("div", { "data-testid": `${testId}`, className: classNames(classes.innerShadow, classes[position]) });
};
const ComposedInnerShadow = compose(withStyles(styles, { withTheme: true }), pure)(InnerShadow);
ComposedInnerShadow.displayName = 'InnerShadow';
export default ComposedInnerShadow;
//# sourceMappingURL=InnerShadow.js.map